import type { InvestorData } from '@workspace/api-backend'
import { useEditMode } from '../../../hooks/use-edit-mode'
import { InvestorEdit } from './investor-edit'
import { InvestorView } from './investor-view'

type InvestorProfileProps = {
  investor: InvestorData
  permissions?: { canEdit: boolean }
}

export function InvestorProfile({ investor, permissions }: InvestorProfileProps) {
  const { isEditMode, startEditing, stopEditing } = useEditMode()
  const canEdit = permissions?.canEdit ?? false

  if (canEdit && isEditMode) {
    return <InvestorEdit onExitEdit={stopEditing} />
  }

  return <InvestorView investor={investor} canEdit={canEdit} onEdit={startEditing} />
}
